export const bet_amount = (t) => ({
	BET_AMOUNT_TITLE: {
		value: t('common.bet_amount'),
		config: {
			fill: '#7571CA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	BET_AMOUNT_VALUE: {
		value: '',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	}
});
